import shape1 from  './Rectangle 453.svg'
import heroImage from './Lady on phone.png'
import sideImage from './side-Image.png'

export {
    shape1,heroImage,sideImage
}